import { Util } from '../core-utilities/Util';
import { CacheSerializer } from './Cache.interface';

export interface FileReaderEventTarget extends EventTarget {
    result: string;
}

export interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;
    getMessage(): string;
}

/**
 * A noop serializer that leaves the data the same.
 */
export class DefaultCacheSerializer implements CacheSerializer<any, any> {
    serialize(data: any) {
        return new Promise((resolve) => {
            resolve(data);
        });
    }
    deserialize(data: any) {
        return new Promise((resolve) => {
            resolve(data);
        });
    }
}

/**
 * Serializer to convert from a Blob to a string and back again
 */
export class BlobSerializer implements CacheSerializer<Blob, string> {
    serialize(blob: Blob): Promise<string> {
        return new Promise((resolve) => {
            const fileReader = new FileReader();
            fileReader.onload = function (e: ProgressEvent) {
                resolve((e.target as any).result);
            };
            fileReader.readAsDataURL(blob);
        });
    }

    deserialize(data: string): Promise<Blob> {
        return new Promise((resolve) => {
            resolve(Util.dataURItoBlob(data));
        });
    }
}
